import { API } from '../http';
import { NEW_ENDPOINTS } from '../http/endpoints';
import { message } from 'antd';

export const fetchAllScoreTags = () => async dispatch => {
  try {
    const {
      data: { tags }
    } = await API.post(NEW_ENDPOINTS.ADMIN.SCORE.GET_ALL);
    dispatch({ type: 'ScoreTags/SET', payload: tags });
    return tags;
  } catch (e) {
    message.error('Failed to load score tags list');
  }
};

export const fetchUserScoreHistory = async userId => {
  try {
    const {
      data: { history }
    } = await API.post(NEW_ENDPOINTS.ADMIN.SCORE.GET_HISTORY, {
      user_id: userId
    });
    return history;
  } catch (e) {
    message.error('Failed to load score history');
  }
};

export const removeUserScore = async scoreItem => {
  try {
    await API.post(NEW_ENDPOINTS.ADMIN.SCORE.MODIFY, {
      id: scoreItem.id,
      user_id: scoreItem.user_id,
      tag: scoreItem.tag_id,
      operation: 'remove',
      applied_by: scoreItem.applied_by
    });
  } catch (e) {
    message.error('Failed to remove score');
  }
};

export const addUserScore = (scoreItem) => async (dispatch, getState) => {
  try {
    const adminId = getState().user.id;
    await API.post(NEW_ENDPOINTS.ADMIN.SCORE.MODIFY, {
      user_id: scoreItem.user_id,
      tag: scoreItem.tag_id,
      operation: 'add',
      applied_by: adminId,
      note: scoreItem.note
    });
  } catch (e) {
    message.error('Failed to add score');
  }
};
